import { Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  setSelectValidError,
  updateRendererFormState,
  verifyModal,
} from "../../../slices/common/reducer";
import { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import { showToast } from "../../../common/Toaster/Toaster";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAgMemberData,
  getFormRenderer,
  readAll,
  readProfileData,
  updateFromRenderer,
} from "../AgMemberService";
import { checkButtonAccess } from "../../../Utils/CommonUtils";

const ProfileFormModal = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.agMember.selectedAgMember.tabs);
  const activeTab = useSelector(
    (state) => state.agMember.selectedAgMember.activeTab
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const modalShow = useSelector((state) => state.common.modalShow);
  const agMemberData = useSelector((state) => state.agMember.agMemberData);

  const data = useSelector(
    (state) => state.agMember.selectedAgMember.detailsData
  );
  console.log("data", data);
  const params = useParams();
  const ProfileFieldsJSON = useSelector(
    (state) => state.agMember.ProfileFieldsJSON
  );
  const ProfileLayoutJSON = useSelector(
    (state) => state.agMember.ProfileLayoutJSON || []
  );
  const profileJson = useSelector((state) => state.agMember.profileJson);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const [isEditing, setIsEditing] = useState(!data?.profile_complete);
  const { id } = useParams();
  const [mode, setMode] = useState(data?.profile_complete ? "VIEW" : "EDIT");
  const viewmode = useSelector((state) => state.agMember.mode);

  const [index, setIndex] = useState(0);

  const handlePrevious = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  useEffect(() => {
    if (data.parentid && data.organizationid) {
      getFormRenderer(data.parentid, data.organizationid);
    }
  }, [data.parentid, data.organizationid]);

  useEffect(() => {
    if (modalShow) {
      readProfileData(id, mode);
    }
  }, [mode]);

  useEffect(() => {
    if (modalShow) {
      dispatch(updateRendererFormState(profileJson));
    }
    return () => {
      dispatch(updateRendererFormState(data));
    };
  }, [modalShow, dispatch]);

  const handleSubmit = async (e, action) => {
    e.preventDefault();
    // const action = e.nativeEvent.submitter.getAttribute("data-action");
    if (formState) {
      dispatch(setSelectValidError(false));
      if (index < ProfileLayoutJSON.length - 1) {
        setIndex(index + 1);
      } else {
        try {
          const response = await updateFromRenderer(
            formState,
            params.id,
            "AGM",
            params.id,
            viewmode
          );
          dispatch(verifyModal(false));

          showToast("Profile form updated successfully", "success");

          if (response && response.status === 200) {
            await readAll(params.id, mode);

            dispatch(openModal(false));
          }
          dispatch(openModal(false));
        } catch (error) {
          showToast(
            error?.response?.data?.error_message || "An error occurred",
            "error"
          );
        }
      }
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
    setMode("EDIT");
  };

  useEffect(() => {
    setIsEditing(!data?.profile_complete);
    setMode(data?.profile_complete ? "VIEW" : "EDIT");
  }, [data?.profile_complete]);

  const renderProfileJson = () => {
    if (!profileJson) return <p>No profile data available</p>;

    const parsedProfile = profileJson;

    const formatDate = (value) => {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return value;
    };

    const renderChildFields = (childData) => {
      const fields = [];

      childData?.forEach((child, index) => {
        if (
          child.elementtype === "select" ||
          child.elementtype === "textfield" ||
          child.elementtype === "email" ||
          child.elementtype === "date" ||
          child.elementtype === "number" ||
          child.elementtype === "textarea" ||
          child.elementtype === "year"
        ) {
          const labelKey = `${child.elementid}-${child.elementtype}`;
          const fieldLabel =
            ProfileFieldsJSON[labelKey]?.["display-fieldlabel"] ||
            child.elementid;
          const databaseLabel = ProfileFieldsJSON[labelKey]?.["database-label"];
          const fieldValue = parsedProfile[databaseLabel];
          console.log("Database Label:", databaseLabel);
          const formattedValue =
            databaseLabel === "ag_name"
              ? data?.ag_name || "-"
              : child.elementtype === "year" && fieldValue
              ? fieldValue.match(/(\d{4})$/)?.[1] || fieldValue
              : fieldValue &&
                typeof fieldValue === "string" &&
                fieldValue.match(/^\d{4}-\d{2}-\d{2}/)
              ? formatDate(fieldValue)
              : fieldValue;

          fields.push(
            <Col span={12} className="form-view-field" key={child.elementid}>
              <div className="view-label">{fieldLabel} :</div>
              <div className="view-value">{formattedValue || "-"}</div>
            </Col>
          );
        }

        if (child.child) {
          fields.push(renderChildFields(child.child));
        }
      });

      return fields;
    };

    return (
      <div>
        <div className="proposal-container">
          <div className="form-json-view">
            {ProfileLayoutJSON.map((element, ind) => (
              <fieldset className="form-fieldset" key={element.elementid}>
                <legend className="">
                  {element.name || `Section ${ind + 1}`}
                </legend>
                <Row className="form-row">
                  {element.child && renderChildFields(element.child)}
                </Row>
              </fieldset>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(verifyModal(false));
    if (id) {
      readAll(id, viewmode);
    }
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setMode("VIEW");
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={handleClose}
      centered
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
      size="xl"
    >
      <Form onSubmit={handleSubmit}>
        <ModalHeader
          className="p-3 bg-info-subtle form-render-header"
          toggle={handleClose}
        >
          Profile Form
          {data.profile_complete === true &&
          (checkButtonAccess ? checkButtonAccess("EDIT", "AGM_PRO") : true) ? (
            <>
              <Button
                // variant="primary"
                className={isEditing ? "primary-outline" : "primary"}
                onClick={isEditing ? handleCancelClick : handleEditClick}
              >
                {isEditing ? "Cancel" : "Edit"}
              </Button>
            </>
          ) : (
            <></>
          )}
        </ModalHeader>
        <ModalBody className="modal-body">
          {isEditing || !data.profile_complete === true ? (
            <>
              <div className="proposal-container">
                <div className="tab-wrapper">
                  {ProfileLayoutJSON?.map((element, ind) => (
                    // <div key={element.elementid}>
                    <div
                      key={element.elementid}
                      className={index === ind ? "active-tab" : "inactive-tab"}
                      style={{
                        pointerEvents: ind <= index ? "auto" : "none",
                        opacity: ind <= index ? 1 : 0.5,
                      }}
                    >
                      {renderElement(
                        element,
                        ProfileFieldsJSON,
                        formState,
                        () => {
                          setIndex(ind);
                        },
                        index,
                        ind
                      )}
                    </div>
                  ))}
                </div>
                <div className="form-content">
                  {ProfileLayoutJSON[index]?.child?.length > 0 ? (
                    ProfileLayoutJSON[index]?.child.map((it) =>
                      renderElement(
                        it,
                        ProfileFieldsJSON,
                        formState,
                        null,
                        null,
                        false
                      )
                    )
                  ) : (
                    <p>No fields to display</p>
                  )}
                </div>
              </div>
              <div className="navigation-buttons">
                <Button
                  color="primary previous"
                  onClick={handlePrevious}
                  disabled={index === 0}
                >
                  Previous
                </Button>
                {index === ProfileLayoutJSON.length - 1 ? (
                  <Button
                    type="submit"
                    color="success"
                    // onClick={(e) => handleSubmit(e, "finish")}
                  >
                    Finish
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    color="primary"
                    // data-action="next"
                    disabled={index === ProfileLayoutJSON.length - 1}
                    // onClick={(e) => handleSubmit(e, "next")}
                  >
                    Next
                  </Button>
                )}
              </div>
            </>
          ) : (
            renderProfileJson()
          )}
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default ProfileFormModal;
